import { sortAlphabeticallyByProps } from '@ftr/contracts/shared/ArrayUtils'
import { Country } from '@ftr/contracts/shared/Country'
import { SelectItem } from '@ftr/forms'

export function getSupportedCountriesAsSelectItems(
  supportedCountries: Country[],
  addEmptyValue: boolean = true,
  required: boolean = false,
): SelectItem<string>[] {
  const countries = supportedCountries
    .map(cntry => ({ key: cntry.name, value: cntry.code }))
    .sort(sortAlphabeticallyByProps('key'))

  if (addEmptyValue) {
    countries.unshift({ key: required ? 'Country' : 'Country (Optional)', value: '' })
  }

  return countries
}
